import React from 'react';
import { NavLink } from 'react-router-dom';
import './../../styles/cliente/sidebar_left.css';

const Sidebar_left = () => {
    return (
        <div className="container-sidebar">
            <NavLink to="/cliente/cuenta">Cuenta</NavLink>
            <NavLink to="/cliente/direccion">Direccion</NavLink>
        </div>
    );
};

export default Sidebar_left;
